import { useCallback, useEffect, useState } from 'react';
import { Button, Modal, Typography } from '@eventbrite/marmalade';
import { defineMessages, useIntl } from 'react-intl';
import { useFollowContext } from '../useFollowContext';
import { setFollowOrganizerStatus } from './gdpr-utils';
import styles from './FollowButtonGDPRModal.module.scss';

const messages = defineMessages({
  title: {
    id: 'Get alerts for new events',
    defaultMessage: 'Get alerts for new events',
  },
  description: {
    id: "By clicking okay, you are agreeing to receive marketing emails and notifications about creators you follow so that you don't miss out.",
    defaultMessage:
      "By clicking okay, you are agreeing to receive marketing emails and notifications about creators you follow so that you don't miss out.",
  },
  noThanks: {
    id: 'No Thanks',
    defaultMessage: 'No Thanks',
  },
  okay: {
    id: 'Okay',
    defaultMessage: 'Okay',
  },
  closeModal: {
    id: 'Close GDPR dialog',
    defaultMessage: 'Close GDPR dialog',
  },
});

export function FollowButtonGDPRModal() {
  const intl = useIntl();
  const { shouldShowGDPRModal, setShouldShowGDPRModal, userId } = useFollowContext();
  const [isClientSideRendered, setIsClientSideRendered] = useState(false);

  useEffect(() => setIsClientSideRendered(true), []);

  const closeModal = useCallback(() => {
    setShouldShowGDPRModal(false);
  }, [setShouldShowGDPRModal]);

  const handleReject = useCallback(() => {
    if (userId) {
      setFollowOrganizerStatus(userId, false);
    }
    closeModal();
  }, [userId, closeModal]);

  const handleAccept = useCallback(() => {
    if (userId) {
      setFollowOrganizerStatus(userId, true);
    }
    closeModal();
  }, [userId, closeModal]);

  if (!isClientSideRendered) {
    return null;
  }

  return (
    <Modal
      isShown={shouldShowGDPRModal}
      headerTitle={intl.formatMessage(messages.title)}
      handleClose={closeModal}
      closeTitle={intl.formatMessage(messages.closeModal)}
    >
      <div className={styles.content}>
        <Typography variant="body-md" align="center">
          {intl.formatMessage(messages.description)}
        </Typography>

        <div className={styles.actions}>
          <Button variant="secondary" onClick={handleReject}>
            {intl.formatMessage(messages.noThanks)}
          </Button>
          <Button variant="primary" onClick={handleAccept}>
            {intl.formatMessage(messages.okay)}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
